<template>
  <div style="top: 1.2rem;position:absolute;width: 100%">
    <p class="title1">购买历史</p>
    <p class="title2">若无显示购买历史，请前往钱包APP查看转账记录</p>
    <ul class="payList">
      <li @click="goinfo">
        <i class="logo"></i>
        <div class="t_cont">
          <p>月度会员</p>
          <span>03.20 19:57</span>
        </div>
        <p class="status">购买成功</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'fbeePayHistrony',
  methods: {
    goinfo: function () {
      this.$router.push({path: '/fbeePayHistronyById'})
    }
  }
}
</script>

<style scoped>
  .title1{
    font-family: PingFangSC-Medium;
    font-size: 0.907rem;
    color: #584F60;
    height: 1.267rem;
    line-height: 1.267rem;
    position: absolute;
    left: 0.427rem;
    top: 0px;
  }
  .title2{
    font-family: PingFangSC-Regular;
    font-size: 0.373rem;
    color: #9B9B9B;
    height: 0.533rem;
    line-height: 0.533rem;
    position: absolute;
    left: 0.427rem;
    top: 1.347rem;
  }
  .payList{
    width: 100%;
    position: absolute;
    left: 0rem;
    top: 2.0933rem;
  }
  .payList li{
    height: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    background-image: url("/static/goico.png");
    background-size:  0.2rem 0.4rem;
    background-repeat: no-repeat;
    background-position: 9.307rem  50%;
  }
  .payList li .logo{
    width: 0.933rem;
    height: 0.933rem;
    background-image: url("/static/vipLogo.png");
    background-size: 100%;
    position: absolute;
    left: 0.427rem;
  }
  .payList li .t_cont{
    position: absolute;
    left: 1.6rem;
  }
  .payList li .t_cont p{
    font-family: PingFangSC-Medium;
    font-size: 0.48rem;
    color: #4A4A4A;
  }
  .payList li .t_cont span{
    font-family: PingFangSC-Regular;
    font-size: 0.32rem;
    color: #C6C5CC;
  }
  .payList li .status{
    font-family: PingFangSC-Regular;
    font-size: 0.48rem;
    color: #F5A623;
    text-align: right;
    position: absolute;
    right: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/fbeePayHistrony.vue